var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdManagerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2454.3 2454.3",
    style: {
      enableBackground: "new 0 0 2454.3 2454.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FBBC04;}\r\n\t.st1{fill:#34A853;}\r\n\t.st2{fill:#3B80EF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2385.8,1385L1385,2385.8c-91.3,91.3-239.4,91.3-330.7,0c-91.4-91.3-91.3-239.4,0-330.7l1000.9-1000.9 c91.3-91.3,239.4-91.3,330.7,0C2477.2,1145.6,2477.2,1293.6,2385.8,1385L2385.8,1385z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -1212.9008 1512.7477)",
    className: "st1",
    cx: 1219.6,
    cy: 2220.5,
    rx: 233.9,
    ry: 233.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1562.3,561.4l-500.5,500.4l330.7,330.7L1893,892.1c91.3-91.3,91.3-239.4,0-330.7 C1801.6,470,1653.6,470,1562.3,561.4L1562.3,561.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M892.1,1893l500.4-500.4l-330.7-330.7l-500.4,500.4c-91.3,91.3-91.3,239.4,0,330.7 C652.7,1984.3,800.8,1984.3,892.1,1893L892.1,1893z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -507.2274 1227.6238)",
    className: "st1",
    cx: 1228.3,
    cy: 1226.1,
    rx: 233.9,
    ry: 233.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1400.1,399.2L399.2,1400.1c-91.3,91.3-239.4,91.3-330.7,0c-91.3-91.3-91.3-239.4,0-330.7L1069.4,68.5 c91.3-91.3,239.4-91.3,330.7,0C1491.4,159.8,1491.4,307.9,1400.1,399.2L1400.1,399.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1234.7,
    cy: 233.9,
    r: 233.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdManagerLogo);
export default __webpack_public_path__ + "static/media/ad-manager-logo.987df5e4e9a57a8be13e4f63ab95fe8d.svg";
export { ForwardRef as ReactComponent };